import { rankWith, scopeEndsWith } from "@jsonforms/core"

const linkControlTester = (uiSchema) => {
  return uiSchema.specializedType && uiSchema.specializedType === 'Assign' ? 7 : 0
}

export default linkControlTester